var _circle, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpillerbytte(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.8746,
    cy: 14.0766,
    r: 13.3408,
    fill: "#F9F9F9",
    stroke: "#DCDCDC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.4101 12.8413L7.50035 15.9538L9.9041 13.0753",
    stroke: "#D52B1E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3391 16.0678L20.2503 12.9538L17.8451 15.8331",
    stroke: "#229E45",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2226 12.9816C20.7486 16.3153 18.6224 19.4928 15.3401 20.2783C13.2024 20.7853 10.9543 20.1549 9.39185 18.6103",
    stroke: "#229E45",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.50335 15.9358C7.07457 14.2156 7.35156 12.3953 8.27261 10.8805C9.19366 9.36561 10.6823 8.28203 12.4069 7.87106C14.6941 7.32909 17.0939 8.09077 18.6499 9.85256",
    stroke: "#D52B1E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpillerbytte);
export default __webpack_public_path__ + "static/media/spillerbytte.84fd173db0ec47b1be7efc05effce09f.svg";
export { ForwardRef as ReactComponent };